import React from 'react';
import { Link } from 'react-router-dom';
import { LogoFull } from '../../assets/icons';
import { Button } from 'antd';
import { Images } from '../../config/images';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const NotFound = () => {
  return (
    <div className='errorpage'>
      <div className='errorpage__logo'>
        <LogoFull />
      </div>
      <div className='errorpage__content'>
        <h1 className='errorpage__content__title'>Oops!</h1>
        <p className='subhead-1 errorpage__content__detail'>We can’t find the page you’re looking for.</p>
        <p className='errorpage__content__name'>404 Error</p>
        <Button className='errorpage__content__link ant-btn-primary--alt' type='primary'>
          <Link to='/'>Go to Home</Link>
        </Button>
      </div>
      <div className='errorpage__image'>
        <LazyLoadImage src={Images.error404} alt='Person with binoculars' />
      </div>
    </div>
  );
};

export default NotFound;
